import { render, staticRenderFns } from "./TableResponsiveLoading.vue?vue&type=template&id=0cc1d9d9&scoped=true&"
import script from "./TableResponsiveLoading.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TableResponsiveLoading.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc1d9d9",
  null
  
)

export default component.exports